import React, { Component } from "react";
import * as actions from '../redux/time_off_summary_actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

export class AgentTimeOffSummary extends Component {
    constructor(props) {
		super(props);
        
        let { User } = this.props;

        if(this.props.actions.fetchTimeOffSummaryAction) {
			this.props.actions.fetchTimeOffSummaryAction({ agentID: User.userID});
        }

        //bind methods
        this.createTable = this.createTable.bind(this);
    }
    
    createTable() {
        if(this.props.SummaryItems) {
            
            let table = []
            
            // Outer loop to create parent
            for (let i = 0; i < this.props.SummaryItems.length; i++) {
                let children = []
                let p = this.props.SummaryItems[i];

                let enumMap = this.props.TimeOffEnumItems;
                let enumDisplayName = "";
                
                if(enumMap) {
                    let enumObj = enumMap[p.type];
                    enumDisplayName = enumObj.value;
                }

                if(enumDisplayName === "VTO") {
                    p.total = p.planned + p.taken;
                }

                children.push(<td key={i}>{enumDisplayName}</td>)
                children.push(<td key={"balance" + i}><span className="hrs">{enumDisplayName === "VTO" ? "-" : p.balance}</span>{enumDisplayName !== "VTO" ? " Hrs" : ""}</td>)
                children.push(<td key={"planned" + i}><span className="hrs">{p.planned}</span> Hrs</td>)
                children.push(<td key={"taken" + i}><span className="hrs">{p.taken}</span> Hrs</td>)
                children.push(<td key={"total" + i}><span className="hrs">{p.total}</span> Hrs</td>)
                
                //Create the parent and add the children
                table.push(<tr key={"row" + i}>{children}</tr>)
            }
            return table
        }
    }

    render() {
            return (
                <table className="summaryTable">
                    <tbody>
                        <tr className="line">
                            <th>Type</th>
                            <th>Balance</th>
                            <th>Planned</th>
                            <th>Taken</th>
                            <th>Total</th>
                        </tr>
                        { this.createTable() }
                    </tbody>
                </table>
            );
        }
    }

function mapStateToProps(state) {
	return {
        User: state.common.user,
        SummaryItems: state.timeoff.SummaryItems,
        TimeOffEnumItems: state.timeoff.TimeOffEnumItems
    };
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch)
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AgentTimeOffSummary);


// WEBPACK FOOTER //
// ./src/features/timeoff/TimeOff/AgentTimeOffSummary.js